module.exports = "<template>\n    <sio-cell if.bind=\"_column\" item.bind=\"item\" column.bind=\"_column\"></sio-cell>\n</template>\n";